import { useEffect, useState } from "react";
import { githubRepos } from "@/data/portfolio";

export const useGithubRepos = () => {
  const [repos, setRepos] = useState(githubRepos);
  const [live, setLive] = useState(false);

  useEffect(() => {
    fetch("https://api.github.com/users/GameDevKaran/repos?per_page=100&sort=updated")
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error("github api"))))
      .then((data) => {
        const authored = data
          .filter((r) => !r.fork && !r.archived)
          .map((r) => ({
            name: r.name,
            language: r.language || "—",
            url: r.html_url,
          }));
        if (authored.length > 0) {
          setRepos(authored);
          setLive(true);
        }
      })
      .catch(() => {});
  }, []);

  return { repos, live };
};
